module.exports = __webpack_public_path__ + "img/1707294525433.c214f5c3.jpg";